import { useMutation } from "@tanstack/vue-query";

import { AudioDevicePreferences } from "@/enums/preferences";
import myApiService from "@/services/modules/my";

import type { UpdateAudioDevicePayload } from "@/models/preferences";

interface AudioDeviceMutationParams {
  type: "input" | "output";
  deviceId: string;
  label: string;
}

export const useAudioDeviceMutation = ({
  onSuccess,
  onError,
}: {
  onSuccess: (params: AudioDeviceMutationParams) => void;
  onError: (params: { type: "input" | "output" }) => void;
}) => {
  return useMutation({
    mutationFn: ({ type, deviceId, label }: AudioDeviceMutationParams) => {
      const payload: UpdateAudioDevicePayload = {
        key:
          type === "input"
            ? AudioDevicePreferences.input
            : AudioDevicePreferences.output,
        value: { device_id: deviceId, label },
      };
      return myApiService.savePreferences(payload);
    },
    onSuccess: (_data, variables) => {
      onSuccess(variables);
    },
    onError: (_error, variables) => {
      onError({ type: variables.type });
    },
  });
};
